const getKeyByValue = (object, value) => Object.keys(object).find((key) => object[key] === value) || null;
export {
  getKeyByValue
};
//# sourceMappingURL=get-key-by-value.js.map
